import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Select, Interaction } from 'ol/interaction';
import Feature from 'ol/Feature';
import { Base, Layer } from 'ol/layer';
import { InteractionService } from '../services/interaction.service';
import { FormatUtils } from '../utils/format.utils';
import { MapComponent } from './map.component';

@Component({
    selector: 'app-select-interaction',
    template: ''
})
export class SelectInteractionComponent implements OnInit, OnDestroy {
    select: Select | Interaction;
    selected: Subject<Feature>;
    layer: Base;

    @Input() layerId: string;
    @Input() hover: boolean;
    @Output() onSelected: EventEmitter<any> = new EventEmitter();

    constructor(
        private _map: MapComponent,
        private _interaction: InteractionService
    ) {
        this.selected = new Subject();
        this.selected.subscribe((olFeature: Feature) => {
            this.onSelected.emit(FormatUtils.writeGeoJson(olFeature));
        });
    }

    ngOnInit(): void {
        this.layer = this.getSelectLayer();
        if (this.layer) {
            this.select = this._interaction.getSelectInteraction(this.layer, this.hover, this.selected);
            this._map.instance.addInteraction(this.select);
        }
    }

    ngOnDestroy(): void {
        this._map.instance.removeInteraction(this.select);
    }

    getSelectLayer(): Base {
        return this._map.instance.getLayers().getArray().find((olLayer: Layer) => olLayer.get('id') === this.layerId);
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/select.component.ts